import React, { Fragment, useRef, useEffect } from 'react';
import echarts from 'echarts';
import { useMounted, useUnmount } from '@/utils/hooks';
import ChartLegend from './ChartLegend';
import { LOADING_CONFIGF, BASIC_CONFIG } from '../config/recommend-chart';
import { PROVICNE_MAP } from '../config';
import china from '../../../../node_modules/echarts/map/json/china';
import styles from '../styles/common.less';

const FORMATTER_FUNC = data =>
  data?.map(item => {
    const { provinceID, areaRewardPercentage, highRewardList, star, level } = item;
    const regionText = PROVICNE_MAP[provinceID];
    const levelNum = star || level;
    return {
      name: regionText,
      value: levelNum,
      areaRewardPercentage,
      highRewardList,
      // provinceID,
    };
  }) || [];

const RecommendChart = ({
  chartData,
  loading = false,
  levelData,
  canClick = false,
  onClick,
  type = 'isp',
}) => {
  const recommendChart = useRef(null);

  useMounted(() => {
    recommendChart.current = echarts.init(document.getElementById('chart'));
    echarts.registerMap('china', china);
    recommendChart.current.setOption(BASIC_CONFIG);
  });

  // 底图数据更新之后自动重绘底图
  useEffect(() => {
    const formatData = FORMATTER_FUNC(chartData);
    if (recommendChart.current)
      recommendChart.current.setOption({
        series: [
          {
            data: formatData,
          },
        ],
      });
  }, [chartData, recommendChart]);

  useEffect(() => {
    if (loading && recommendChart.current) {
      recommendChart.current.showLoading('default', LOADING_CONFIGF);
    } else {
      recommendChart.current.hideLoading();
    }
  }, [loading]);

  useEffect(() => {
    if (canClick && recommendChart.current) {
      recommendChart.current.setOption({
        geo: {
          silent: false,
        },
        tooltip: {
          formatter: onClick,
        },
      });
    }
  }, [canClick, onClick]);

  useUnmount(() => {
    if (recommendChart.current) recommendChart.current.dispose();
  });

  return (
    <Fragment>
      <div className={`${styles.chartWrapper} ${styles.ispChart}`}>
        <div className={styles.chartBox} id="chart"></div>
      </div>
      <ChartLegend data={levelData} type={type} />
    </Fragment>
  );
};
export default RecommendChart;
